import { Link } from "react-router-dom";
import { categories } from "@/mocks/promotions";

export default function CategoriesSection() {
  return (
    <section className="py-20 bg-[#e0f7fa]/30">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-[#00b4c8] uppercase tracking-widest">
            Explora
          </span>
          <h2
            className="text-3xl md:text-5xl font-bold text-[#2d1a0e] mt-2"
          >
            Nuestras Delicias
          </h2>
          <p className="text-[#6b5b6e] mt-3 text-base max-w-xl mx-auto">
            Descubre nuestra variedad de productos y cae en la tentación de San7o Pecado.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {[...categories]
            .sort((a, b) => a.priority - b.priority)
            .map((cat) => (
              <Link
                key={cat.id}
                to={`/menu?categoria=${encodeURIComponent(cat.name)}`}
                className="group relative rounded-2xl overflow-hidden aspect-square cursor-pointer block"
              >
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-white font-semibold text-sm leading-tight">
                    {cat.name}
                  </p>
                </div>
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-up-line text-white text-sm"></i>
                </div>
              </Link>
            ))}
        </div>
      </div>
    </section>
  );
}
